module.exports = __webpack_public_path__ + "img/payment-retail.02ea07af.png";